(function () {

  function $(id) {
    return document.getElementById(id);
  }

  var $budgetRangeInput = $("budgetRangeInput");

  if (!$budgetRangeInput) {
    return;
  }

  var $budgetValue = $("budgetValue");
  var $budgetAmount = $("budgetAmount");
  var $budgetTrack = $("budgetTrack");

  var defaultBudgetValues = [1, 2, 4, 6, 10, 15, 25, 40];
  var $checkboxes = document.querySelectorAll('input[name="interested_in[]"]');
  var userHasInteracted = false;

  var minimumBudgetValues = {
    'branding': 2,
    'website': 6,
    'design': 1,
    'animation': 5
  };

  /**
   *  array of the current values on the slider.
   */
  var budgets;
  var currentBudget = 0;

  /**
   * Changes the slider values when checkboxes change.
   */
  function onCheckboxChange() {
    updateBudgets();
    updateRangeInputAttributes();
    updateSlider();
  }

  function onSliderChange() {
    userHasInteracted = true;
    updateSlider();
  }

  /**
   * Updates the number of range steps and sets the slider value
   * to something reasonable when a checkbox has been changed.
   */
  function updateRangeInputAttributes() {
    $budgetRangeInput.max = budgets.length - 1;

    var i = budgets.indexOf(currentBudget);

    if (i === -1 || !userHasInteracted) {
      $budgetRangeInput.value = 0;
    } else {
      $budgetRangeInput.value = i;
    }
  }

  /**
   * Updates the slider UI and hidden field when the slider changes.
   */
  function updateSlider() {
    var index = $budgetRangeInput.value;
    var budget = budgets[index];
    var percent = index / (budgets.length - 1) * 100;

    setBudget(budget);
    setBudgetTrack(percent);
  }

  /**
   * Sets the budget amount on the label and hidden text field. 
   */
  function setBudget(val) {
    currentBudget = val;
    var budgetString = '£' + val + 'k';

    if (budgets.indexOf(val) == budgets.length - 1) {
      budgetString += '+';
    }

    $budgetAmount.innerText = budgetString;
    $budgetValue.value = budgetString;
  }

  /**
   * Sets the yellow bar.
   */
  function setBudgetTrack(percent) {
    $budgetTrack.setAttribute("style", "width: " + percent + "%;");
  }

  /**
   * Sets the budgets variable based on the checkbox values.
   */
  function updateBudgets() {
    var minimumBudget = getMinimumBudget();

    var filteredBudgets = defaultBudgetValues.filter(function(budget) {
      return (budget > minimumBudget);
    });

    if (filteredBudgets.indexOf(minimumBudget) === -1 && minimumBudget !== 0) {
      filteredBudgets.unshift(minimumBudget);
    }

    budgets = filteredBudgets;
  }

  /**
   * Returns the minimum budget based on the checkboxes.
   */
  function getMinimumBudget() {
    var minimumBudget = 0;
    var i;

    for (i = 0; i < $checkboxes.length; i += 1) {
      if ($checkboxes[i].checked) {
        minimumBudget += minimumBudgetValues[$checkboxes[i].value];
      }
    }

    return minimumBudget;
  }

  function init() {
    updateBudgets();

    var i;
    var $checkbox;

    for (i = 0; i < $checkboxes.length; i += 1) {
      $checkbox = $checkboxes[i];

      $checkbox.addEventListener("change", onCheckboxChange);
    }

    $budgetRangeInput.addEventListener("input", onSliderChange);
  }

  init();
})();
